import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router'
import { BrowserRouter as Router } from "react-router-dom";
import PropTypes from 'prop-types';
import HomeTemplate from '../templates/home';
import EpisodeTemplate from '../templates/episode';
import IfiTemplate from '../templates/ifi';
import Playlist from '../playlist';


export default class MainRouter extends Component {
    constructor(props) {
        super(props);
        //console.log("[MainRouter] props:", props);
        this.routerRef = React.createRef();

    }


    componentDidMount() {
        this.props.onReady(this.routerRef.current);
    }

    render() {
        const { props: mainProps } = this;
        const { series } = mainProps;

        //const { player } = this.state;
        const breadcrumb = {
            "path": series.path,
            "label": series.title
        }

        return (

            <Router ref={this.routerRef}>
                <Switch>
                    <Route path={series.path} exact render={ props => {
                        
                        return(
                            <HomeTemplate {...props} {...series } />
                        )
                    } } />
                    <Route path={`${series.path}/ifi*`} render={ props => {
                        return(
                            <IfiTemplate {...props} breadcrumb={breadcrumb}  />
                        )
                    } } />
                    <Route path={`${series.path}/:episodeId`} render={ props => {
                        return(
                            <EpisodeTemplate {...props} summary={series.summary} breadcrumb={breadcrumb}  />
                        )
                    } } />
                    <Redirect to={series.path} />

                </Switch>
                <Playlist key="playlist"  />
            </Router>

        )
    }

    static get propTypes() {
        return {
            onReady: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            onReady: () => {}
        }
    }
}